import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';
import * as moment from 'moment';

//conv dd/mm/yyyy to timestamp

export function manufacturedDateValidator(control: FormControl) {
    let date = control.value;
    let day, month, year;
    if (date) {
        var dateMoment = moment(date, "YYYY");
        var currentYear = moment();
        if(dateMoment.isValid()){
            if(currentYear.isBefore(dateMoment)){
                return {
                    invalidManufactureYear: true
                }
            }

            if(currentYear.diff(dateMoment, "years", true)>17){

                return {
                    moreAge: true
                }

            }
        }
        
        if(!dateMoment.isValid()){

            return {
                invalid: true
            }

        }
    }


    return null;
}

@Directive({
    selector: '[manufacturedDateValidator][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useValue: manufacturedDateValidator,
            multi: true
        }
    ]
})
export class ManufacturedDateValidator {
}